module.exports = __webpack_public_path__ + "img/logo.08aa0c28.png";